import { Component, OnInit, Input, Inject, TemplateRef, Optional, OnDestroy } from '@angular/core';
import { NgxExcelColumnTemplateContext, NgxExcelColumn } from '../../models/models';
import { NgxExcelComponent, NgxExcelComponentRef } from '../ngx-excel/ngx-excel.component';

@Component({
  selector: 'ngx-excel-column',
  template: ''
})

export class NgxExcelColumnComponent<T> implements OnInit, OnDestroy {

  private _locked = false;
  private _readonly = false;
  private _invisible = false;
  private _sortable = false;

  @Input() name: string;
  @Input() label: string;
  @Input() width: number;
  @Input() tooltip: string;
  @Input() index: number;
  @Input()
  set locked(value: boolean) { this._locked = value === false ? false : true; }
  get locked(): boolean { return this._locked; }
  @Input()
  set readonly(value: boolean) { this._readonly = value === false ? false : true; }
  get readonly(): boolean { return this._readonly; }
  @Input()
  set invisible(value: boolean) { this._invisible = value === false ? false : true; }
  get invisible(): boolean { return this._invisible; }
  @Input()
  set sortable(value: boolean) { this._sortable = value === false ? false : true; }
  get sortable(): boolean { return this._sortable; }

  @Input() template: TemplateRef<NgxExcelColumnTemplateContext>;
  @Input() templateEdit: TemplateRef<NgxExcelColumnTemplateContext>;
  @Input() templateHead: TemplateRef<NgxExcelColumnTemplateContext>;
  @Input() onClickedCallback: (context: any) => void;

  constructor(
    @Optional() @Inject(NgxExcelComponentRef) protected excelComponent: NgxExcelComponent
  ) { }

  ngOnInit() {
    const name = this.name || '';
    if (!this.excelComponent || name.length === 0) { return; }

    const excelColumn = {} as NgxExcelColumn;
    excelColumn.name = name;
    excelColumn.label = this.label || null;
    excelColumn.width = Math.max(typeof (this.width) === 'string' ? parseInt(this.width, 10) : this.width || 160, 60);
    excelColumn.index = Math.max(typeof (this.index) === 'string' ? parseInt(this.index, 10) : this.index || 0, 0);
    excelColumn.tooltip = this.tooltip || null;
    excelColumn.locked = this._locked;
    excelColumn.readonly = this._readonly;
    excelColumn.invisible = this._invisible;
    excelColumn.sortable = this._sortable;

    excelColumn.template = this.template || null;
    excelColumn.templateEdit = this.templateEdit || null;
    excelColumn.templateHead = this.templateHead || null;

    if (this.onClickedCallback) {
      excelColumn.onClickedCallback = this.onClickedCallback;
      excelColumn.readonly = true;
    } else {
      excelColumn.onClickedCallback = null;
    }

    this.excelComponent.appendColumn(excelColumn);
  }

  ngOnDestroy() {
    const name = this.name || '';
    if (!this.excelComponent || name.length === 0) { return; }
    this.excelComponent.removeColumn(name);
  }

}
